<template>
    <div class="import-form-library-wrapper">
        <div class="row wrapper border-bottom white-bg page-heading">
            <div class="col-10">
                <h2>{{ $t("navigations.importtoformlibrary") }}</h2>
            </div>
        </div>
        <div class="wrapper wrapper-content px-0">
            <div class="import-center-stage">
                <div class="import-card">
                    <div class="import-card-header">
                        <div class="import-icon">
                            <i class="fa fa-file-import"></i>
                        </div>
                        <div>
                            <h4 class="import-title mb-1">{{ $t("navigations.importtoformlibrary") }}</h4>
                            <p class="import-subtitle mb-0">
                                Select approved form templates from the current study and import them into the Form Library.
                            </p>
                        </div>
                    </div>

                    <div class="import-stats">
                        <div class="stat-pill">
                            <span class="stat-value">{{ templateList.length }}</span>
                            <span class="stat-label">{{ $t("navigations.templates") }}</span>
                        </div>
                        <div class="stat-pill">
                            <span class="stat-value">{{ selectedTemplateIds.length }}</span>
                            <span class="stat-label">{{ $t("navigations.selected") }}</span>
                        </div>
                    </div>

                    <div class="import-card-body">
                        <label class="import-label mb-1">{{ $t("navigations.select") }} {{ $t("navigations.templates") }}</label>
                        <Multiselect
                            mode="multiple"
                            :searchable="true"
                            trackBy="templateName"
                            v-model="selectedTemplateIds"
                            :placeholder="$t('navigations.select')"
                            :tag-placeholder="$t('navigations.selected')"
                            :selected-label="$t('navigations.selected')"
                            valueProp="templateId"
                            label="templateName"
                            :options="templateList"
                            :hideSelected="false"
                            :closeOnSelect="false"
                            :maxHeight="300"
                            class="multiselect-template-theme mr-0"
                        >
                            <template v-slot:option="{ option }">
                                {{ option.templateName }} ({{ option.version }}) - {{ option.languageCode.toUpperCase() }}
                            </template>
                        </Multiselect>

                        <div class="import-actions">
                            <span class="import-hint" v-if="!selectedTemplateIds.length">
                                {{ $t("navigations.no forms selected") }}
                            </span>
                            <button
                                type="button"
                                class="save_btn import-submit px-4 py-1"
                                :disabled="!selectedTemplateIds.length"
                                @click.prevent="ImportFun()"
                            >
                                <i class="fa fa-download mr-1"></i>{{ $t("navigations.import") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="./importtoformlibrary.js"></script>
<style scoped>
.import-form-library-wrapper .wrapper-content {
    min-height: calc(100vh - 100px);
}

.import-center-stage {
    display: flex;
    justify-content: center;
    padding: 48px 16px;
}

.import-card {
    width: 100%;
    max-width: 680px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 6px 24px rgba(16, 24, 40, 0.08);
    border: 1px solid #eef0f4;
    padding: 32px 36px;
}

.import-card-header {
    display: flex;
    align-items: flex-start;
    gap: 16px;
}

.import-icon {
    flex: 0 0 56px;
    width: 56px;
    height: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, var(--primary-color, #007bff), var(--secondary-color, #618bd7));
    color: #fff;
    font-size: 22px;
}

.import-title {
    font-size: 20px;
    font-weight: 600;
    color: #2b2f38;
}

.import-subtitle {
    font-size: 13.5px;
    color: #76808f;
    max-width: 480px;
}

.import-stats {
    display: flex;
    gap: 12px;
    margin: 24px 0;
}

.stat-pill {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 14px 10px;
    border-radius: 10px;
    background: #f4f6fb;
    border: 1px solid #eef0f4;
}

.stat-value {
    font-size: 22px;
    font-weight: 700;
    color: var(--primary-color, #007bff);
    line-height: 1.2;
}

.stat-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #8b93a1;
    margin-top: 2px;
}

.import-card-body {
    border-top: 1px solid #eef0f4;
    padding-top: 22px;
}

.import-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #2b2f38;
}

.import-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 22px;
}

.import-hint {
    font-size: 12.5px;
    color: #9aa2af;
}

.import-submit {
    margin-left: auto;
}

.import-submit:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.multiselect-template-theme {
    --ms-option-bg-selected-pointed: rgb(210, 210, 210);
    --ms-option-bg-selected: rgb(210, 210, 210);
    --ms-option-color-selected: #000;
    --ms-option-color-selected-pointed: #000;
    --ms-radius: 8px;
    --ms-line-height: 0.8;
    --ms-option-font-size: 0.8rem;
    --ms-font-size: 0.8rem;
}

:deep(.multiselect-dropdown) {
    max-height: 300px !important;
    overflow-y: auto !important;
}

:deep(.multiselect-options) {
    max-height: 300px !important;
    overflow-y: auto !important;
}

.save_btn:hover {
    background-color: #18a689;
}

@media (max-width: 576px) {
    .import-card {
        padding: 24px 20px;
    }

    .import-actions {
        flex-direction: column;
        align-items: stretch;
    }

    .import-submit {
        margin-left: 0;
    }
}
</style>